import { LeadForm } from './LeadForm';
import { Phone, Mail, Clock } from 'lucide-react';

export const ContactSection = () => {
  return (
    <section id="contact" className="section-padding bg-[#2C3E50] relative" data-testid="contact-section">
      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left content */}
          <div className="text-white">
            <span className="text-[#F59E0B] font-medium text-sm uppercase tracking-wider mb-4 block">
              Kontakta oss
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-6">
              Redo att ge dina fönster nytt liv?
            </h2>
            <p className="text-white/80 text-lg mb-10 max-w-lg">
              Fyll i formuläret så återkommer vi inom 24 timmar med en kostnadsfri offert. 
              Du kan också ringa eller maila oss direkt.
            </p>

            {/* Contact methods */}
            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-white/10 flex items-center justify-center">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-white/60 text-sm mb-1">Ring oss</div>
                  <a
                    href="tel:08-254604"
                    className="text-white text-xl font-semibold hover:text-[#F59E0B] transition-colors duration-200"
                    data-testid="contact-phone-link"
                  >
                    08-25 46 04
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-white/10 flex items-center justify-center">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-white/60 text-sm mb-1">E-post</div>
                  <a
                    href="mailto:info@vimalar.se"
                    className="text-white text-xl font-semibold hover:text-[#F59E0B] transition-colors duration-200"
                    data-testid="contact-email-link"
                  >
                    info@vimalar.se
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-white/10 flex items-center justify-center">
                  <Clock className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-white/60 text-sm mb-1">Svarstid</div>
                  <div className="text-white text-xl font-semibold">
                    Inom 24 timmar
                  </div>
                </div>
              </div>
            </div>

            {/* ROT info */}
            <div className="mt-10 p-6 bg-white/10 border border-white/20">
              <h4 className="text-white font-semibold mb-2">ROT-avdrag</h4>
              <p className="text-white/80 text-sm">
                Du kan dra av 30% av arbetskostnaden via ROT-avdrag. 
                Vi sköter all administration – du betalar bara den reducerade summan.
              </p>
            </div>
          </div>

          {/* Right - Form */}
          <div className="animate-fade-in-up">
            <LeadForm id="lead-form" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
